import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Transactions from './pages/Transactions';
import NewTransaction from './pages/NewTransaction';
import EditTransaction from './pages/EditTransaction';
import TransactionDetail from './pages/TransactionDetail';
import Monitoring from './pages/Monitoring';
import Laundry from './pages/Laundry';
import Bookings from './pages/Bookings';
import Stock from './pages/Stock';
import Collection from './pages/Collection';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import Reports from './pages/Reports';
import PaymentReports from './pages/PaymentReports';
import PerformaKoleksi from './pages/PerformaKoleksi';
import KasMonitoring from './pages/KasMonitoring';
import Receipts from './pages/Receipts';
import ReceiptPage from './pages/ReceiptPage';
import Today from './pages/Today';
import Settings from './pages/Settings';
import './App.css';

function Protected({ children }) {
  const { user, loading } = useAuth();
  // Tujuan asli disimpan supaya setelah login tidak dilempar ke dashboard.
  // Penting untuk pintasan /scan: sesi habis -> login -> lanjut ke scan.
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen bg-ivory flex items-center justify-center">
        <div className="text-center">
          <img src="/logo.png" alt="Deyran Gallery" className="w-14 h-14 rounded-full object-cover mx-auto ring-2 ring-gold/50" />
          <p className="text-sm text-mocha mt-3">Memuat…</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

function OwnerOnly({ children }) {
  const { user } = useAuth();
  if (user?.role === 'karyawan') {
    return (
      <div className="py-24 text-center" data-testid="owner-only-block">
        <p className="font-display text-2xl text-brown-dark">Khusus Owner</p>
        <p className="text-sm text-mocha mt-2">Halaman ini hanya bisa diakses oleh owner.</p>
      </div>
    );
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/transaksi" element={<Transactions />} />
            <Route path="/transaksi/baru" element={<NewTransaction />} />
            <Route path="/transaksi/:id" element={<TransactionDetail />} />
            <Route path="/transaksi/:id/edit" element={<EditTransaction />} />
            <Route path="/pemantauan" element={<Monitoring />} />
            <Route path="/laundry" element={<Laundry />} />
            <Route path="/booking" element={<Bookings />} />
            <Route path="/stok" element={<Stock />} />
            <Route path="/koleksi" element={<Collection />} />
            <Route path="/customer" element={<Customers />} />
            <Route path="/customer/:id" element={<CustomerDetail />} />
            <Route path="/laporan" element={<OwnerOnly><Reports /></OwnerOnly>} />
            <Route path="/laporan-pembayaran" element={<OwnerOnly><PaymentReports /></OwnerOnly>} />
            <Route path="/performa-koleksi" element={<OwnerOnly><PerformaKoleksi /></OwnerOnly>} />
            <Route path="/kas" element={<OwnerOnly><KasMonitoring /></OwnerOnly>} />
            {/* Pintasan layar utama HP: satu ketukan langsung ke dialog Scan Nota. */}
            <Route path="/scan" element={<Navigate to="/kas?scan=nota" replace />} />
            <Route path="/scan-transfer" element={<Navigate to="/kas?scan=transfer" replace />} />
            <Route path="/nota" element={<Receipts />} />
            <Route path="/nota/:id" element={<ReceiptPage />} />
            <Route path="/aktivitas" element={<OwnerOnly><Today /></OwnerOnly>} />
            <Route path="/pengaturan" element={<OwnerOnly><Settings /></OwnerOnly>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
